import ActionsCellComponent from "./ActionsCellComponent";
import React, { useEffect, useState } from "react";
import { Backdrop, Dialog, Tooltip } from "@mui/material";

import { BiSortAlt2 } from "react-icons/bi";
import infoIcon from "assets/concessionInfo.png";
import { ReactComponent as Sort } from "assets/img/svg/sort.svg";
import { ReactComponent as SortDesc } from "assets/img/svg/sortDesc.svg";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";

import NoRowOverlay from "../../../../masters/holidayMaster/NoRowOverlay";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import APopover from "views/pages/manage/common/a-popover";
import { ReactComponent as EyeIcon } from "assets/img/svg/eye_open.svg";

import {
  generateQuantityDropdown,
  getQuantityDropdownItem,
} from "../../stockReturn/constant";
import { gridSelectStyles } from "../../stockReturn/StockReturnDialog";

import { IssuedMaterialData } from "./IssuedStockList";
import ApplicationIdPopup from "./ApplicationIdPopup";
import {
  MaterialToBeIssued,
  getTableTableHeader,
  PsidDisplayTooltips,
  ValueWithTooltip,
  IssuedColumn,
  CheckBoxColumn,
  ViewEditBarCode,
  ValueWithOutTooltip,
  CourseDetails,
} from "./TableColumn";
import styles from "../styles.module.scss";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import ALoader from "views/pages/manage/common/a-loader";
import AChip from "views/pages/manage/common/chip/AChip";

export const MaterialDetailsV2 = ({ dataRows, isAllReturn = false }) => {
  if (isAllReturn || !dataRows?.length) return "";
  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <EyeIcon onClick={isAllReturn ? () => {} : onClick} />
      )}
      menuComponent={(closeForm) => (
        <IssuedMaterialData hideBarcode={true} dataRows={dataRows} />
      )}
    />
  );
};

const TableHeader = ({
  issueStockCheckBoxHandler,
  selectedStudentIds,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
  ...rest
}) => {
  const handleSort = (sortOrder) => {
    setSortOrder(sortOrder);
  };

  const handleSortBy = (sortBy) => {
    setSortBy(sortBy);
  };

  return (
    <div
      className={`${styles["custom-table-parent"]} ${styles["header-column"]}`}
    >
      <div>
        <CheckBoxColumn
          {...{
            issueStockCheckBoxHandler,
            isAll: true,
            isChecked: selectedStudentIds?.length > 0,
          }}
        />
      </div>

      <div>
        PSID
        <span className={`ml-1 ${styles.pointer}`}>
          {sortBy === "psid" ? (
            sortOrder === "asc" ? (
              <Sort onClick={() => handleSort("desc")} />
            ) : (
              <SortDesc onClick={() => handleSort("asc")} />
            )
          ) : (
            <BiSortAlt2 onClick={() => handleSortBy("psid")} />
          )}
        </span>
      </div>
      <div>
        Application ID
        <span className={`ml-1 ${styles.pointer}`}>
          {sortBy === "applicationId" ? (
            sortOrder === "asc" ? (
              <Sort onClick={() => handleSort("desc")} />
            ) : (
              <SortDesc onClick={() => handleSort("asc")} />
            )
          ) : (
            <BiSortAlt2 onClick={() => handleSortBy("applicationId")} />
          )}
        </span>
      </div>
      <div>
        Student Name
        <span className={`ml-1 ${styles.pointer}`}>
          {sortBy === "studentName" ? (
            sortOrder === "asc" ? (
              <Sort onClick={() => handleSort("desc")} />
            ) : (
              <SortDesc onClick={() => handleSort("asc")} />
            )
          ) : (
            <BiSortAlt2 onClick={() => handleSortBy("studentName")} />
          )}
        </span>
      </div>
      <div>
        <Tooltip title={"Program Plan"}>Program...</Tooltip>
        <span className={`ml-1 ${styles.pointer}`}>
          {sortBy === "programAction" ? (
            sortOrder === "asc" ? (
              <Sort onClick={() => handleSort("desc")} />
            ) : (
              <SortDesc onClick={() => handleSort("asc")} />
            )
          ) : (
            <BiSortAlt2 onClick={() => handleSortBy("programAction")} />
          )}
        </span>
      </div>
      <div>Material Already Issued</div>
      <div>Material to be Issued</div>
      <div>Barcode</div>
      <div style={{ marginLeft: "auto" }}>Action</div>
    </div>
  );
};

const TableHeaderReturnStock = ({ forBarcoded = true }) => {
  return (
    <div
      className={`${styles["custom-table-parent-return-stock"]} ${styles["header-column"]}`}
    >
      <div>{`${
        forBarcoded ? "Barcoded" : "Non-barcoded"
      } material details`}</div>
      <div>Issued Quantity</div>
      <div>{`Select ${forBarcoded ? "barcodes" : "return quantity"}`}</div>
      <div>{forBarcoded ? `Return Quantity` : ""}</div>
      <div>UOM</div>
    </div>
  );
};

const IssueStockCustomTable = ({
  students,
  issueStockToApplication,
  issueStockCheckBoxHandler,
  selectedStudentsForIssueStock,
  selectedStudentIds,
  alreadyIssuedTshirtMaterial,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
}) => {
  const [schoolTieupDialog, setSchoolTieupDialog] = useState({
    isOpen: false,
    applicationId: "",
  });

  const closeSchoolDialog = () => {
    setSchoolTieupDialog({ isOpen: false, applicationId: "" });
  };

  if (students.length === 0) {
    return (
      <>
        <TableHeader
          {...{
            issueStockCheckBoxHandler,
            selectedStudentIds,
          }}
        />
        <NoRowOverlay />
      </>
    );
  }
  return (
    <>
      <TableHeader
        {...{
          issueStockCheckBoxHandler,
          selectedStudentIds,
          sortBy,
          setSortBy,
          sortOrder,
          setSortOrder,
        }}
      />
      {students.map((student, index) => {
        return (
          <div
            key={student.applicationId}
            className={`${styles["custom-table-parent"]} ${styles["table-body"]}`}
          >
            <div>
              <CheckBoxColumn
                {...{
                  issueStockCheckBoxHandler,
                  student,
                  isChecked:
                    selectedStudentsForIssueStock[student.applicationId] ||
                    false,
                  disabled: !student?.isEligibleForStockIssuance,
                }}
              />
            </div>
            <div
              className="d-flex align-items-center mr-3"
              style={{ width: "130px" }}
            >
              <PsidDisplayTooltips
                student={student}
                alreadyIssuedTshirtMaterial={
                  alreadyIssuedTshirtMaterial.find(
                    (item) => item.applicationId === student.applicationId
                  )?.alreadyIssuedTshirtMaterial || []
                }
              />
              <IconButtonWrapper
                onClick={() => {
                  setSchoolTieupDialog({
                    isOpen: true,
                    applicationId: student.applicationId,
                  });
                }}
              >
                <EyeIcon />
              </IconButtonWrapper>
            </div>

            <div className="d-flex">
              <ValueWithTooltip
                student={student}
                value={student.applicationId}
              />
              <ApplicationIdPopup rowData={student} />
              {/* <CourseDetails
                courseId={student.courseId}
                applicationId={student.applicationId}
              /> */}
            </div>

            <div>
              <ValueWithTooltip student={student} value={student.studentName} />
            </div>

            <div>
              <ValueWithOutTooltip
                student={student}
                value={student.programAction}
              />
            </div>

            <div>
              <IssuedColumn student={student} />
            </div>

            <div>
              <MaterialToBeIssued student={student} />
            </div>

            <div>
              <ViewEditBarCode rowData={student} />
            </div>
            <div style={{ marginLeft: "auto" }}>
              <ActionsCellComponent
                student={student}
                issueStockToApplication={(e) =>
                  issueStockToApplication(e, index)
                }
                selectedStudentIds={selectedStudentIds}
              />
            </div>
          </div>
        );
      })}

      {schoolTieupDialog.isOpen && (
        <SchoolTieUpDialog
          schoolTieupDialog={schoolTieupDialog}
          closeDialog={closeSchoolDialog}
        />
      )}
    </>
  );
};

const getBarCodeDropdown = (material) => {
  // console.log(
  //   material?.barCodes?.filter(
  //     (materialItem) => materialItem?.returnTransactionId !== null
  //   ),
  //   "xxx",
  //   material
  // );
  if (!Array.isArray(material?.barCodes)) return [];
  return material?.barCodes
    ?.filter((material) => !material?.returnTransactionId)
    .map((item) => ({
      label: item?.barcode,
      value: item?.barcode,
      barcode: item?.barcode,
      materialId: material?.materialId,
      materialDescription: material?.materialDescription,
      uom: material?.uom,
      serialNumberProfile: material?.serialNumberProfile,
    }));
};

export const ReturnConsumptionTable = ({
  rows = [],
  form,
  formHandler,
  isAllReturn,
  dataRows = [],
  forBarcoded = true,
}) => {
  const notReturnBarcode = (rows, materialId) => {
    return rows.filter(
      (item) =>
        item?.returnTransactionId === null &&
        +item?.materialNumber === +materialId
    );
  };
  const barcodedMaterialsRows = rows?.filter(
    (item) => item?.serialNumberProfile?.toLowerCase() !== "na"
  );
  const nonBarcodedMaterialsRows = rows?.filter(
    (item) => item?.serialNumberProfile?.toLowerCase() === "na"
  );
  if (
    (forBarcoded ? barcodedMaterialsRows : nonBarcodedMaterialsRows).length ===
    0
  ) {
    return (
      <>
        <TableHeaderReturnStock forBarcoded={forBarcoded} />
        <NoRowOverlay />
      </>
    );
  }
  return (
    <>
      <TableHeaderReturnStock forBarcoded={forBarcoded} />
      {(forBarcoded ? barcodedMaterialsRows : nonBarcodedMaterialsRows).map(
        (material, index) => {
          const avlBarCode = getBarCodeDropdown(material);
          return (
            <div
              key={material.materialId}
              className={`${styles["custom-table-parent-return-stock"]} ${styles["table-body"]}`}
            >
              <div>
                <span className="mr-2">{material?.materialDescription}</span>
                <MaterialDetailsV2
                  isAllReturn={isAllReturn}
                  dataRows={notReturnBarcode(dataRows, material?.materialId)}
                />
              </div>
              <div>{material?.barCodes.length}</div>
              <div>
                {forBarcoded ? (
                  <AAutoComplete
                    placeholder={
                      avlBarCode?.length ? "Select barcode" : "Stock returned"
                    }
                    items={avlBarCode}
                    currentValue={form[material?.materialId] || ""}
                    handleChange={(value) => {
                      formHandler(value, material?.materialId);
                    }}
                    // height="32px"
                    style={gridSelectStyles}
                    isShowCount={true}
                    isDisabled={isAllReturn || !avlBarCode?.length}
                  />
                ) : (
                  <AAutoComplete
                    placeholder={
                      avlBarCode?.length
                        ? "Select quantity (max upto 50)"
                        : "Stock returned"
                    }
                    items={
                      avlBarCode?.length > 50
                        ? generateQuantityDropdown(50)
                        : generateQuantityDropdown(avlBarCode?.length)
                    }
                    currentValue={getQuantityDropdownItem(
                      form[material?.materialId]?.length ?? ""
                    )}
                    handleChange={(value) => {
                      formHandler(
                        avlBarCode?.slice(0, value?.value),
                        material?.materialId
                      );
                    }}
                    // height="32px"
                    style={gridSelectStyles}
                    isMulti={false}
                    isDisabled={isAllReturn || !avlBarCode?.length}
                  />
                )}
              </div>
              <div>
                {forBarcoded
                  ? isAllReturn
                    ? "-"
                    : form[material?.materialId]?.length || 0
                  : ""}
              </div>

              <div>{material?.uom || "-"}</div>
            </div>
          );
        }
      )}
    </>
  );
};

const SchoolTieUpDialog = ({ schoolTieupDialog, closeDialog }) => {
  const [isFetching, setIsFetching] = useState(true);
  const [response, setResponse] = useState({});

  const { isOpen, applicationId } = schoolTieupDialog;

  useEffect(() => {
    getInfo();
  }, []);

  const getInfo = async () => {
    setIsFetching(true);
    const response = await fetchAllPromisedData(
      `${endpoint.getSchoolTieUpByApplicationId}/${applicationId}`
    );

    if (response?.applicationId) setResponse(response);
    else setResponse({});

    setIsFetching(false);
  };

  return (
    <Dialog
      aria-label="School Tie-Up Information"
      open={isOpen}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          height: "270px",
          width: "400px",
          padding: "20px",
        },
      }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0 text-bold">School Tie-Up Information</h3>

        <IconButtonWrapper
          aria-label="Close the dialog"
          //   tabIndex="0"
          onClick={closeDialog}
          disabled={isFetching}
        >
          <CrossIcon />
        </IconButtonWrapper>
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-center">
          <p className="text-sm text-bold mr-3 mb-0">
            School Tie-Up Program Status:
          </p>
          <AChip
            label={response?.isSchoolTieUp ? "Yes" : "No"}
            success={response?.isSchoolTieUp}
          />
        </div>

        <div
          style={{
            padding: "0.5rem",
            color: response?.isSchoolTieUp ? "#1e40af" : "#4b5563",
            background: response?.isSchoolTieUp ? "#3eff6ff" : "#f9fafb",
          }}
          className="mx-3 mt-4 text-sm text-center rounded-md"
        >
          <span className="mr-3">
            <img src={infoIcon} width={20} height={20} />
          </span>
          {response?.isSchoolTieUp
            ? "This student is enrolled in a School Tie-Up program and may have special arrangements or benefits."
            : "This student is not enrolled in any School Tie-Up program."}
        </div>
      </div>

      <Backdrop
        sx={(theme) => ({
          color: "#fff",
          zIndex: 1500,
        })}
        open={isFetching}
      >
        <ALoader />
      </Backdrop>
    </Dialog>
  );
};

export default IssueStockCustomTable;
